import type { FaireProductEntity } from "../../entity_types/product";

export const p_8bjcne2w5q: FaireProductEntity = {
  token: "p_8bjcne2w5q",
  type: "product",
  name: 'Daisy Tumbler-Olive-3.5"H(10oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/5d8e4a0f6d2775a56a12ff142e60c2a993c21effd4a4b3c6b740cdae73840f7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/73b8554bb08192eca8759ebf8ea3124bfd3e6b0f076f70fdaf89da03db1a5867.jpeg",
    "https://cdn.faire.com/fastly/2be7ce8382e9f179fbef2dcedd4f292575e0f99c595dbe59f06ecbcd8ce665dc.jpeg",
    "https://cdn.faire.com/fastly/d489ffc5e59fd261012f6f4393e2679a7a2ad3b02a36ba5080d04a9471eabe9b.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Sip in style with this elegant Daisy Tumbler – where vintage flair meets everyday functionality. Featuring a delicate embossed floral motif in a rich olive hue, this glass brings a burst of beauty to any table setting. This tumbler adds instant elegance and a splash of personality. Available in additional shapes.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:14.358Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
